'use client';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button/Button';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Link from 'next/link';
import React from 'react';

type BottomPaginationProps = {
  pageNumber: number;
  totalPages: number;
};

export default function BottomPagination({ pageNumber, totalPages }: BottomPaginationProps) {
  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      paddingTop="20px"
      marginTop="20px"
      alignItems={'center'}
      sx={{
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'divider',
      }}
    >
      <NavButton
        direction={'back'}
        pageNumber={pageNumber}
        totalPages={totalPages}
        disabled={pageNumber <= 1}
      />
      <Pagination
        disabled={totalPages == 1}
        count={totalPages}
        shape="rounded"
        page={pageNumber}
        siblingCount={0}
        boundaryCount={1}
        hideNextButton
        hidePrevButton
        renderItem={(item) => {
          const href = item.page != null ? `/page/${item.page}#all` : undefined;
          return <PaginationItem component={href ? Link : 'button'} href={href} {...item} />;
        }}
      />
      <NavButton
        direction={'next'}
        pageNumber={pageNumber}
        totalPages={totalPages}
        disabled={pageNumber >= totalPages}
      />
    </Box>
  );
}

type NavButtonProps = {
  direction: 'back' | 'next';
  pageNumber: number;
  totalPages: number;
  disabled: boolean;
};

const NavButton = ({ direction, pageNumber, totalPages, disabled }: NavButtonProps) => {
  const targetPage = direction === 'next' ? pageNumber + 1 : pageNumber - 1;
  return (
    <Button
      component={Link}
      href={`/page/${targetPage}#all`}
      disabled={disabled}
      {...(direction == 'next'
        ? { endIcon: <ArrowForwardIcon /> }
        : { startIcon: <ArrowBackIcon /> })}
      sx={{
        fontSize: '14px',
        color: 'text.secondary',
        textTransform: 'none',
        ':hover': {
          backgroundColor: 'background.default',
        },
      }}
    >
      {direction == 'next' ? 'Next' : 'Previous'}
    </Button>
  );
};
